import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { BarChartData } from 'Molecules/InsightsChart/chartBuilder';
import { BaseInsightPayload } from '../InsightDataPayload';
import { parseEventsTypePayload } from '../payloads/eventsTypePayload';
import { InsightChartFactory } from '../insightChartFactory';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';
import intl from 'react-intl-universal';

export const buildEventsTypeInsightFactory = (
  payload: BaseInsightPayload
): InsightChartFactory => {
  const parsedPayload = parseEventsTypePayload(payload);
  const { data } = parsedPayload.data.attributes;

  return (props) => {
    const chart = new ChartBuilder()
      .setChartType(ChartType.V_BAR_STACK_LINE)
      .setProps({
        chartData: data as BarChartData,
        onDrillDown: props.onDrillDown,
        xAxisFieldName: 'event_type',
        yAxisFieldNames: ['event_count', 'scheduled_hours'],
        legendNames: [
          intl.get('INSIGHT.LEGEND.EVENT_COUNT'),
          intl.get('INSIGHT.LEGEND.SCHEDULED_HOURS'),
        ],
      })
      .build();

    return DefaultChartWithTrendSupport({
      chartComponent: chart,
    });
  };
};
